export default {
  shinkansen: {
    title: '日本新幹線訂票 | Triplabo',
    caption: '日本新幹線官方合作平台',
    description:
      'JR 官方認證合作夥伴。主要新幹線路線提前預訂，掃描 QR Code 即可快速入站乘車。',
    departure: '出發',
    arrival: '到達',
    departureDate: '出發日期',
    ticketType: '新幹線車票',
    earliestTime: '最早發車時間',
    latestTime: '最晚發車時間',
    travelTime: '乘車時間',
    attractions: '熱門景點',
    stock: {
      sufficient: '座位充足',
      limited: '余票不足',
      soldOut: '票已售罄'
    },
    book: {
      reserve: '預訂',
      selectSeat: '選擇座位'
    },
    preference: {
      earliestDeparture: '最早出發',
      fastestArrival: '最快到達',
      lowestPrice: '價格最低'
    },
    popularRoutes: {
      title: '熱門路線',
      jr: {
        name: '日本JR官方合作平台',
        description: '直連日本鐵道官方訂票系統，值得信賴'
      },
      qr: {
        name: '秒出票，掃碼進站乘車',
        description: '無需排隊取票，直接掃碼進站暢通無阻'
      },
      reserve: {
        name: '提前一天預訂，退改方便',
        description:
          '行程有變？乘車1日前可取消重訂！\n（*自由席當天內均可使用）'
      }
    },
    usageInstructions: {
      title: '使用說明',
      step1: {
        title: '線上預訂車票，獲取二維碼乘車券',
        description: '*根據JR規定，新幹線車票目前只能在出發前1個月內出票。'
      },
      step2: {
        title: '前往新幹線站台，掃碼進站',
        description: '*若遇到錯誤提示，請出示二維碼乘車券給閘機附近的工作人員。'
      },
      step3: {
        title: '尋找站台和列車',
        description: '*自由席請尋找設置了自由席車廂的列車，座位先到先得。'
      }
    },
    duration: {
      hoursAndMinutes: '{{hours}}時{{minutes}}分',
      minutes: '{{minutes}}分',
      approximately: '約{{duration}}'
    },
    tags: {
      shinkansen: '新幹線',
      qrcode: '二維碼乘車'
    },
    faq: {
      q1: '購買後如何乘坐新幹線？',
      a1: '本商品為直接用二維碼乘坐新幹線的電子票券，無需在車站換票。您支付後系統將在新幹線官方後台實時訂票，乘車用二維碼將展示在小程序訂單票券中，並發送到您下單時所填寫的郵箱，請行前確認收到的二維碼票券信息是否無誤。\n購買多張票時會收到多張二維碼票券，一人一碼，二維碼只可掃一次，敬請注意。 當天請提前前往新幹線的閘機口掃碼進站。在進站後的屏幕上找到票券上的車次所顯示的月台，並看好出發時間和車次乘車（新幹線站台均在大站，人流量大，請至少提前半小時，預留充足時間進站乘車）。',
      q2: '錯過了乘車時間，怎麼辦？',
      a2: '如果您錯過了新幹線的乘車時間，您可以直接乘坐當天內的其他列車的自由席而無需退票。若您想確保有座位，可在車站購買新的指定席車票，但之前購買的票無法取消退款。',
      q3: '能攜帶多大的行李？',
      a3: '您最多可以攜帶三邊合計不超過250cm的行李，否則可能無法攜帶乘車。\n車廂內行李架：每節車廂上方都有行李架，可以放置尺寸適中的手提行李和背包。\n座位前方空間：您也可以利用座位前方空間放置小型行李（會擠壓腿部空間）。\n車廂尾部行李區：部分列車在車廂尾部（最後一節車廂或靠近洗手間處）設有較大的行李存放區，可以放置大件行李，但空間有限，先到先得。*不允許把行李箱放在過道上或座位間通道，以免影響其他乘客通行。'
    }
  }
};
